import { NumberBox } from "devextreme-react";
import LoadingIndicator from "../../../Component/LoadingIndicator";
import { useState } from "react";
import { useAsync, useAsyncFn } from "react-use";
import repository from "./SettingRepository";
import { Button } from "devextreme-react/button";
const AttendanceSettingForm = () => {
  const [latenessTolerance, setLatenessTolerance] = useState(0);

  const state = useAsync(async () => {
    const data = await repository.get({ name: "LATENESS_TOLERANCE" });
    setLatenessTolerance(data.value);
  }, []);

  const [updateState, updateSettings] = useAsyncFn(async (value) => {
    await repository.set({ name: "LATENESS_TOLERANCE", value: value });
  }, []);

  return (
    <div>
      {state.loading || updateState.loading ? (
        <LoadingIndicator />
      ) : state.error || updateState.error ? (
        <div>
          {state.error != null
            ? state.error.message
            : updateState.error.message}
        </div>
      ) : (
        <div className="flex m-2">
          <div className="p-2">
            <div className="dx-field">
              <div className="dx-field-label overflow-visible">
                Lateness Tolerance
              </div>
              <div className="dx-field-value">
                <NumberBox
                  defaultValue={latenessTolerance}
                  onValueChanged={(e) => setLatenessTolerance(e.value)}
                />
              </div>
            </div>

            <div className="flex justify-end mt-4">
              <Button
                width={120}
                text="Simpan"
                type="default"
                stylingMode="contained"
                onClick={() => updateSettings(latenessTolerance)}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AttendanceSettingForm;
